import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "InsuranceContractDashboardPage" */
	'pages/vehicle/InsuranceContract/InsuranceContractDashboardPage'));

export default [{ component, exact: true, path: '/insurance_contracts/:insuranceContractId' }];